import React from 'react';
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import useFetchData from "../../../form/hooks/use-fetch-data.js";

const OtherInformationFilter = ({filter, onChange, onChangeCustom}) => {
    const {situations, instructions} = useFetchData()

    return (
        <SentryRow>
            <div className="col-span-12">
                <InputForm
                    id="roleCrime"
                    value={filter.roleCrime}
                    label="Função no crime"
                    onChange={onChange}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="situation"
                    value={filter.situation}
                    options={situations}
                    label="Situação"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "situation")}
                />
            </div>
            <div className="col-span-6">
                <InputForm
                    id="socialNetwork"
                    value={filter.socialNetwork}
                    label="Rede social"
                    onChange={onChange}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="educationDegree"
                    value={filter.educationDegree}
                    options={instructions}
                    label="Grau de instrução"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "educationDegree")}
                />
            </div>
            <div className="col-span-6">
                <InputForm
                    id="occupation"
                    value={filter.occupation}
                    label="Profissão"
                    onChange={onChange}
                />
            </div>
            <div className="col-span-12">
                <InputForm
                    id="information"
                    value={filter.information}
                    label="Informações do indivíduo"
                    onChange={onChange}
                />
            </div>
        </SentryRow>
    );
};

export default OtherInformationFilter;
